import { useEffect, useState } from "react"

import { Obj, load } from "scrivito"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"

interface UseProductPositionInstallationReferenceObjsArgs {
  installationReferenceIDs: string[] | null | undefined
}

export function useProductPositionInstallationReferenceObjs({
  installationReferenceIDs
}: UseProductPositionInstallationReferenceObjsArgs) {
  const [installationReferenceObjs, setInstallationReferenceObjs] = useState<
    InstallationReferenceObj[] | undefined
  >()

  useEffect(() => {
    setInstallationReferenceObjs(undefined)
    if (installationReferenceIDs && installationReferenceIDs.length > 0) {
      load(() =>
        Obj.onSite(getCurrentSiteID())
          .where("_objClass", "equals", "InstallationReference")
          .and("referenceID", "equals", installationReferenceIDs)
          .toArray()
      ).then(objs =>
        setInstallationReferenceObjs(objs as InstallationReferenceObj[])
      )
    }
    if (installationReferenceIDs && installationReferenceIDs.length === 0) {
      setInstallationReferenceObjs([])
    }
  }, [installationReferenceIDs])

  return {
    installationReferenceObjs
  }
}
